import Vue from 'vue'
import * as _ from 'lodash';
import axios from '@/utils/request';
import Vuex from 'vuex';

export default {
    state: {
        restaurants: [],
        promisesStatus: {},
    },
    mutations: {
        fetchRestaurants(state, payload) {
            // default order by name
            if (state.restaurants.length >0) {
                (state.restaurants).push(...payload);
            } else {
                state.restaurants = _.orderBy(payload, restaurant => restaurant.name);
            }
        },
        setRestaurants(state, payload) {
            state.restaurants = payload;
        },
        createNewRestaurant(state, payload) {
            state.restaurants.push(payload);
        },
        deleteRestaurant(state, payload) {
            state.restaurants.map((restaurant,index) => {
                if (restaurant.id == payload.id) {
                    state.restaurants.splice(index,1);
                }
            })
        },
        editRestaurant(state, payload){
            const index = state.restaurants.findIndex(item => item.id === payload.id);
            Vue.set(state.restaurants, index, payload);
        },
        setPromiseStatus(state, { promiseName, status }) {
            state.promisesStatus[promiseName] = status;
        },
    },

    actions: {
        async fetchRestaurants({ commit, dispatch }, status = 10){
            let promiseName = `fetchRestaurants_${status}`;
            if (!this.state.restaurants.promisesStatus[promiseName]) {
                commit('clearError')
                commit('setLoading', true)

                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/restaurant`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        },
                        params: {
                            'status': status
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchRestaurants', data, status);
                    commit('setPromiseStatus', { promiseName: promiseName, status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            }
        },
        async createNewRestaurant({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/restaurant`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('createNewRestaurant', data);
                commit('addAreaRestaurant', data);
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async deleteRestaurant({commit, dispatch}, payload)
        {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/restaurant/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('deleteRestaurant', data);
                commit('deleteAreaRestaurant', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

        async editRestaurant({commit, dispatch}, formData){
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                formData.append('_method', 'PATCH'); //! put not working on FormData, -> use PATCH && post
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/restaurant/${formData.get('id')}`, formData, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editRestaurant', data)
                commit('editAreaRestaurant', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async setRestaurantStatus({commit, dispatch}, {restaurant_id, status}) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/restaurant/${restaurant_id}`, {'status':status}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: {
                        'inactive':'true'
                    }
                });

                commit('setLoading', false);
                commit('editRestaurant', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
    },
    getters: {
        restaurants (state) {
            return state.restaurants
        },
        restaurantById(state) {
            return restaurantId => {
                return state.restaurants.find(restaurant => restaurant.id === restaurantId)
            }
        }
    }
}
